module.exports = __webpack_public_path__ + "img/visa.f6c87177.png";